import './date-element.scss';

export default {
  group: 'form-group',
  displayWrapper: '',
  dateWrapper: 'input-group',
  date: 'form-control',
  calendarIcon: 'glyphicon glyphicon-calendar',
  calendarButton: 'input-group-addon btn',
  calendarAnchor: 'anchor',
  calendarWrapper: 'calendar',
  label: 'label-override'
};



// WEBPACK FOOTER //
// src/common/form-elements/date-element-folder/date-element.style.js